<template>
    <service-tab class="call-parking-wallboard">
        <template v-if="filteredCallParkings.length" v-slot:header>
            <h1>{{ wallboardName ? wallboardName : $t("call-parking-wallboard.title") }}</h1>

            <base-select
                v-model="selectedCallParkingNumber"
                :options="callParkingDropdownOptions"
                placeholder="panel.services.call-parking.all"
                class="select-call-parking"
            ></base-select>

            <base-button
                @click="onLogoutClick"
                text="Log out"
                color="text"
                class="logout-btn"
            ></base-button>
        </template>

        <template v-slot:body>
            <base-spinner v-if="loading" center></base-spinner>

            <div v-else-if="!filteredCallParkings.length" class="call-parking-wallboard-no-available">{{ $t("panel.services.call-parking.no-call-parkings") }}</div>

            <call-parking-item
                v-else
                v-for="callParking in filteredCallParkings"
                :call-parking="callParking"
                :key="callParking.number"
                is-wallboard
            ></call-parking-item>
        </template>
    </service-tab>
</template>

<script>
import BaseSelect from "../defaults/BaseSelect.vue";
import {mapActions, mapGetters} from "vuex";
import BaseSpinner from "../defaults/BaseSpinner.vue";
import CallParkingItem from "./CallParkingItem.vue";
import ServiceTab from "./ServiceTab.vue";
import SocketIOHelper from "../../helpers/SocketIOHelper";
import breakpoints from "../../plugins/breakpoints";
import callParkingSelectMixin from "../../mixins/callParking/callParkingSelectMixin";
import BaseButton from "../defaults/BaseButton.vue";
import {logOut} from "../../api/authApi";
import {authLogOut} from "../../utils/auth";
import {getCurrentAccessToken} from "../../utils/auth";
import {reloadPage} from "../../utils/DOM";

export default {
    name: "CallParkingWallboard",
    components: {BaseButton, ServiceTab, CallParkingItem, BaseSpinner, BaseSelect},
    mixins: [callParkingSelectMixin],
    data() {
        return {
            loading: true,
            breakpoints
        }
    },
    created() {
        try {
            SocketIOHelper.connect(getCurrentAccessToken())
        } catch (e) {
            console.error(e)
        }

        this.getConfig()
            .then(() => {
                return this.loadContacts()
            })
            .then(() => {
                this.emitBuildExtensions()

                return this.getCallParkings()
            })
            .then(() => {
                this.emitBuildCallParkings()
            })
            .finally(() => this.loading = false)

        SocketIOHelper.socket.on("update_extension_status", this.updateContactStatus)

        SocketIOHelper.socket.on("parked_call", this.onParkedCall)
        SocketIOHelper.socket.on("unparked_call", this.onUnparkedCall)

        SocketIOHelper.socket.on("reload", reloadPage)

        SocketIOHelper.socket.io.on("reconnect", this.onSocketReconnect)
    },
    destroyed() {
        SocketIOHelper.socket.removeAllListeners("update_extension_status")

        SocketIOHelper.socket.removeAllListeners("parked_call")
        SocketIOHelper.socket.removeAllListeners("unparked_call")

        SocketIOHelper.socket.removeAllListeners("reload")

        SocketIOHelper.socket.io.removeListener("reconnect", this.onSocketReconnect)
    },
    computed: {
        ...mapGetters('callParkings', ['callParkings']),
        ...mapGetters('details', ['getContactsByNumber', 'extensions', 'getContactByNumber']),
        ...mapGetters("wallboard", ["wallboardName"])
    },
    methods: {
        ...mapActions('details', ['loadContacts']),
        ...mapActions("callParkings", ["getCallParkings", "addSlot", "removeSlot"]),
        ...mapActions("wallboard", ["getConfig"]),

        onLogoutClick() {
            logOut()
                .catch(() => {})
                .finally(() => authLogOut())
        },

        emitBuildExtensions() {
            SocketIOHelper.emit("build_extensions", this.extensions)
        },

        emitBuildCallParkings() {
            SocketIOHelper.emit("build_call_parkings", this.callParkings.map(callParking => callParking.number))
        },

        updateContactStatus(socketData) {
            const number = socketData.extension
            const status = Number(socketData.status)
            let contactStatus
            if (status === 0) {
                contactStatus = "contact-idle"
            } else if (status === 4 || status === -1 || status === -2) {
                contactStatus = "contact-unavailable"
            } else {
                contactStatus = "contact-busy"
            }

            const contacts = this.getContactsByNumber(number)
            contacts.forEach(contact => contact.status = contactStatus)
        },

        onParkedCall(data) {
            let newSlot = {
                number: parseInt(data.slot_number),
                parked_by_number: data.agent_number === '<unknown>' ? '' : data.agent_number,
                park_started_at_timestamp: data.time,
                park_end_in_seconds: parseInt(data.park_end_in_seconds),
                parked_number: data.callerid
            }
            this.addSlot({callParkingNumber: parseInt(data.park_number), newSlot: newSlot})
        },

        onUnparkedCall(data) {
            this.removeSlot({callParkingNumber: parseInt(data.park_number), slotNumber: parseInt(data.slot_number)})
        },

        onSocketReconnect() {
            this.emitBuildCallParkings()
            this.emitBuildExtensions()
        }
    }
}
</script>

<style scoped>

</style>